import React from "react";
import { Zap, ShieldCheck, Wallet, BadgeCheck } from "lucide-react";
import { features } from "../data/catalog";

const icons = [Zap, ShieldCheck, Wallet, BadgeCheck];

const WhyUs = () => {
  return (
    <section
      id="mengapa"
      data-testid="why-us-section"
      className="relative py-20 sm:py-24"
    >
      <div className="absolute inset-0 -z-10">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#0e0717] to-transparent" />
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs tracking-[0.22em] uppercase text-[#9B5BFF] font-medium">
            — Mengapa DIGIFRIEND
          </div>
          <h2 className="font-display font-extrabold text-4xl sm:text-5xl mt-4 leading-[1.05]">
            Kenapa Kami Jadi <span className="gradient-purple">Pilihan Terbaik?</span>
          </h2>
          <p className="mt-4 text-white/60 text-base">
            Empat alasan kuat yang membuat ratusan pelanggan mempercayakan
            kebutuhan digitalnya kepada kami.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
          {features.map((f, i) => {
            const Ico = icons[i % icons.length];
            return (
              <div
                key={f.title}
                data-testid={`why-card-${i}`}
                className="product-card p-6 sm:p-7"
              >
                <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-[#7B2DFF] to-[#3a0ca3] glow-purple">
                  <Ico size={22} className="text-white" />
                </div>
                <h3 className="font-display font-bold text-xl mt-5">{f.title}</h3>
                <p className="text-white/60 text-sm mt-2 leading-relaxed">{f.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
